import React from 'react';
import { documentsRoutes } from '../../AppRoutes';
import { acceptAdditionalInputFileString, allowedAdditionalFileExtensions, acceptMainInputFileString, allowedMainFileExtensions, maxFileSize, actionTypes, alfrescoAssociations, alfrescoTypes, attachmentStatuses, menuTypes, documentBpActions, signatureStates, documentStatuses, formFieldTypes, formModes, statutoryDocTypes, urls, searchTableTypes, docTypes, alfrescoRoles } from '../../constants';
import { AttachmentForm } from '../attachments/AttachmentForm';
import { FilesAttachmentsForm } from '../attachments/FilesAttachmentsForm';
import { CommentForm } from '../comments/CommentForm';
import { addCommentAction, getCommentsAction } from '../comments/CommentsActions';
import { CommentsForm } from '../comments/CommentsForm';
import { buildFormField, getFormSection, getFormSectionSettings, padWithZeroes, InputContainer } from '../form/Form';
import { AddSignatoryForm } from '../forms/AddSignatoryForm';
import { CheckSignsForm } from '../forms/CheckSignsForm';
import { ExternalSigners } from '../forms/ExternalSigners';
import * as ListOfRelatedDocuments from '../listsOfAlfresco/ListOfRelatedDocuments';
import * as ListOfDocuments from '../listsOfAlfresco/ListOfDocuments';
import { SignersTableForm } from '../forms/SignersTableForm';
import { SignForm } from '../forms/SignForm';
import { StatutoryDocsForm } from '../forms/StatutoryDocsForm';
import * as CheckFunctions from '../helpers/CheckFunctions';
import * as HelperFunctions from '../helpers/HelperFunctions';
import * as ModalDialogsTemplates from '../ModalDialogsTemplates';
import { History } from '../helpers/History';
import * as ModalDialog from '../ModalDialog';
import { PdfViewer } from '../PdfViewer';
import { SubTabs } from '../SubTabs';
import { Svg } from '../Svg';
import { DocumentInfo } from './DocumentInfo';
import { documentTabs } from './DocumentSettings';
import * as ListOfContracts from '../listsOfAlfresco/ListOfContracts';
import * as ListOfUsersTaskExecuters from '../listsOfAlfresco/ListOfUsersTaskExecuters';
import { ListOfAlfresco } from '../listsOfAlfresco/ListOfAlfresco';
import { Table } from '../table/Table';
import i18n from '../../i18n';
import { outgoingDocumentKinds } from '../documents/outgoingDocument';
import { encodeHTMLEntities } from '../helpers/HelperFunctions';
import { dispatcherActionTypes, globalEventDispatcher } from '../helpers/GlobalEventDispatcher';


const mime = require("mime-types");
export async function getFile(id, type, isZip = false) {
	return await fetch(`file/${type === alfrescoTypes.counterpartyAccreditationCard || type === alfrescoTypes.certificate ? "GetXml" : `get${isZip ? "Zip" : ""}`}?nodeRefs=${id.split('/').pop()}`,
			{ method: 'post', headers: { 'Content-Type': 'application/json' } })
		.then(async (reponse) => (await reponse.json())[0]);
}
export async function getPs7Zip(ids) {
	let docIds = ids.join(',');
	return await fetch('/File/GetP7sZip', {
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		body: JSON.stringify({ docIds: docIds })
	})
		.then(async (response) => response.ok ? await response.json() : { errorCode: response.status });
}
export async function downloadFile(id, title = "", type = "", isZip = false) {
	let data = await getFile(id, type, isZip);
	let anchor = document.createElement("a");
	anchor.href = `data:${data.mimeType};base64,${data.content}`;
	anchor.download = `${title ? title : data.fileName}.${mime.extension(data.mimeType)}`;
	anchor.click();
}
export async function getComents() {
	const { prop_sys_node_uuid } = this.state;
	this.setState({
		comments: await getCommentsAction(prop_sys_node_uuid)
	});
}
export async function addComment(comment) {
	const { prop_sys_node_uuid, formMode } = this.state;
	if (prop_sys_node_uuid) {
		let editDate = null;
		let loadedDate = new Date(this.state.dateLoaded);

		if (this.state.comments.length === 0) {
			let docEditDateStr = await getDocumentEditDateStr(prop_sys_node_uuid);
			editDate = new Date(docEditDateStr);
		}
		const comments = await addCommentAction(comment, prop_sys_node_uuid);
		if (comments) {
			if (this.state.comments.length === 0) {
				if (editDate <= loadedDate) {
					this.setState({
						comments: comments,
						dateLoaded: await getDocumentEditDateStr(prop_sys_node_uuid)
					});
				}
				else if (formMode === formModes.read) {
					window.location.reload();
				}
				else {
					this.setState({
						comments: comments
					});
				}
			}
			else {
				this.setState({
					comments: comments
				});
			}
		}
	}
	else {
		comment.newComment = true;
		comment.content = encodeHTMLEntities(comment.content);
		this.setState({
			comments: [...this.state.comments, comment]
		});
	}
	ModalDialog.hideModalDialog('modalDialog');
}
export async function getDocumentEditDateStr(id) {
	const response = await fetch(`Document/GetEditDate?id=${id}`, { method: 'GET' });
	if (response.ok) {
		return await response.json();
	}
	return null;
}
export async function getMainDocumentPdf(state) {
	let { prop_sys_node_uuid, prop_sxcfc_documentName } = state ?? this.state;
	if (prop_sxcfc_documentName === undefined)
		prop_sxcfc_documentName = '';
	let get = async function (path) {
		return await fetch(path, { method: 'post', headers: { 'Content-Type': 'application/json' } })
			.then(async res => {
				if (!res.ok) require('../ModalDialogsTemplates').unknownErrorMessageDialog();
				else {
					let data = await res.json();
					let path = `file/get?nodeRefs=workspace://SpacesStore/${prop_sys_node_uuid}&withSign=${false}`;
					if (!data[0]?.content && !res.url.toLowerCase().includes(path.toLowerCase())) return get(path);
					else if (data[0]?.mimeType === "application/pdf") {
						let fileName = prop_sxcfc_documentName + (!prop_sxcfc_documentName.endsWith('.pdf') ? ".pdf" : "");
						const blob = HelperFunctions.base64toBlob(data[0].content, "application/pdf");
						const url = URL.createObjectURL(blob);
						return [{
							pdfURL: url,
							fileName: fileName,
							id: (new Date().getTime()).toString(),
							nodeRef: `workspace://SpacesStore/${prop_sys_node_uuid}`,
							minType: data[0].mimeType
						}];
					}
				}
			});
	}
	return await get(`file/Get?nodeRefs=workspace://SpacesStore/${prop_sys_node_uuid}&withSign=${true}`);
}
export async function getFormSetting(type, showError = true) {
	const response = await fetch(`Document/Form/${type}`, { method: 'GET', headers: { 'Content-Type': 'application/json' } });
	if (response.ok) {
		let result = await response.json();
		if (result.form) {
			result.form = JSON.parse(result.form);
		}
		return result;
	}
	if (showError) handleGetDocumentError(response.status);
}
export function renderMainFile() {
	if (this.state.mainDocuments?.length > 0) {
		let src = this.state.mainDocuments[0].pdfURL ? this.state.mainDocuments[0].pdfURL :
			((mime.contentType(this.state.mainDocuments[0]?.fileName) === "application/pdf" && this.state?.mainB64Pdf) ? this.state.mainB64Pdf : null);
		if (src) {
			return (
				<div className="doc-pdf" key="meinFileViewer">
					<label className="required table-label">{i18n.t("mainDocumentFile")}</label>
					<PdfViewer src={src} />
				</div>
			);
		}
	}
}
export function getFormFields(form, props) {
	let result = {};
	for (let i = 0; i < form?.Fields?.length; ++i) {
		if (!form.Fields[i].Ignore) {
			let { Name, Type } = form?.Fields[i];
			if (Name === "elevatorData") {
				result['prop_sxcfc_acceptedProducts'] = props['prop_sxcfc_acceptedProducts'];
				result['prop_sxcfc_shippedProducts'] = props['prop_sxcfc_shippedProducts'];
				result['prop_sxcfc_writtenOffProducts'] = props['prop_sxcfc_writtenOffProducts'];
			}
			else {
				let fieldValue = props[Name];
				if (fieldValue && Type === formFieldTypes.datetime) {
					if (fieldValue.includes("T")) {
						let date = new Date(fieldValue).toLocaleDateString("uk-UA").split(".");
						fieldValue = `${date[2]}-${date[1]}-${date[0]}`;
					}
					else {
						fieldValue = fieldValue.split("-");
						fieldValue = `${padWithZeroes(fieldValue[0], 4)}-${fieldValue[1]}-${fieldValue[2]}`;
					}
				}
				result[Name] = (fieldValue || Type === formFieldTypes.bool) ? fieldValue : "";
			}
		}
	}
	return result;
}
export function handlerCloseDocument(pathname) {
	const { formMode, prop_sx_documentType } = this.state;
	if (formMode !== formModes.read) {
		let closeDialog = () => ModalDialog.hideModalDialog('modalDialog');
		let handlerCloseCreateForm = function () {
			closeDialog();
			if (pathname) {
				History.block(true);
				History.push(pathname);
			}
			else {
				window.onbeforeunload = null;
				window.location.replace("/");
			}
		}
		ModalDialog.showModalDialog('modalDialog', i18n.t("attentionTitle"), "", <div className="info-message">{i18n.t("ifNeedSaveMessage")}</div>, "feedPopup", true, [{ title: i18n.t("save"), clickHandler: () => { ModalDialog.hideModalDialog('modalDialog'); this.actionHandlerCallback(actionTypes.save); }, class: "btn-primary" }, {
			title: i18n.t("dontSave"), clickHandler: () => formMode === formModes.create ? handlerCloseCreateForm() : (() => {
				ModalDialog.hideModalDialog('modalDialog');
				window.onbeforeunload = null;
				History.push(window.location.pathname.toLowerCase().replace(formModes.edit.toLowerCase(), formModes.read.toLowerCase()));
			})(), class: "btn-secondary"
		}, { title: i18n.t("cancel"), clickHandler: closeDialog, class: "btn-secondary" }], () => closeDialog());
	}
	else {
		let docRout = documentsRoutes.find((item) => item.type === prop_sx_documentType);
		History.push(docRout.parentUrl);
	}
}
export function handleChangeRelatedDocuments(type = '', rows = []) {
	// eslint-disable-next-line default-case
	switch (type) {
		case actionTypes.preview:
			if (rows?.length > 0) {
				const url = `/document/${formModes.read}/${rows[0]}`;
				try { window.open(url, '_blank').focus(); }
				catch (ex) { console.log(ex); }
			}
			break;
		case actionTypes.add:
			this.state["assoc_sx_relatedDocuments_added"] = rows.map((item) => "workspace://SpacesStore/" + item.columns.Id).join(',');
			this.actionHandlerCallback(actionTypes.save, documentBpActions.addConnection);
			break;
		case actionTypes.remove:
			const currenObject = this;
			const confirmRemoveDialog = function () {
				currenObject.state["assoc_sx_relatedDocuments_removed"] = rows.map((item) => "workspace://SpacesStore/" + item.columns.Id).join(',');
				currenObject.actionHandlerCallback(actionTypes.save, documentBpActions.addConnection);
			}
			ModalDialog.showModalDialog("modalDialog", i18n.t("removing"), "",
				<div className="info-message">{i18n.t("removeRelatedDocumentsMessage")}</div>,
				"feedPopup", true,
				[
					{ title: i18n.t("yes"), clickHandler: confirmRemoveDialog, class: "btn-primary" },
					{ title: i18n.t("no"), clickHandler: () => ModalDialog.hideModalDialog('modalDialog'), class: "btn-secondary" }
				]);
			break;
	}
}
export function renderconnections() {
	const { associations } = this.state;
	const canEdit = this.state.isEditAllowed && (this.state.prop_sx_docKind !== outgoingDocumentKinds.mutualSettlementsAct);
	return (
		<div className="doc-form-block" key="connectionsTab">
			{renderFormHeader.bind(this)()}
			{associations?.relatedDocuments && <ListOfAlfresco typeOfMenu={menuTypes.WithoutMenu} parentComponent={ListOfRelatedDocuments} isEditAllowed={canEdit} withAction={false} type={searchTableTypes.Documents} additionalFilter={{ "Id": associations.relatedDocuments ? associations.relatedDocuments.map(item => item.split("/").pop()) : ["-"] }} actionHandlerCallback={handleChangeRelatedDocuments.bind(this)} />}
		</div>
	);
}
export function mainContractActionHandler(actionType, rows) {
	if (rows.length > 0) {
		const { associations, assoc_sxcfc_contractAssoc_removed } = this.state;
		// eslint-disable-next-line default-case
		switch (actionType) {
			case actionTypes.preview:
				return require('../ModalDialogsTemplates').viewPdfDialog(rows[0].columns.Id);
			case actionTypes.remove:
				let removedAssoc = assoc_sxcfc_contractAssoc_removed;
				if (associations?.contractAssoc?.length > 0) {
					removedAssoc = associations.contractAssoc[0];
				}
				this.setState({
					assoc_sxcfc_contractAssoc_added: '',
					assoc_sxcfc_contractAssoc_removed: removedAssoc,
					mainContract: null
				});
				break;
		}
	}
}
export async function addMainContract(type, rows = []) {
	const { associations } = this.state;
	if (rows.length > 0) {
		let addedAssoc = "workspace://SpacesStore/" + rows[0].columns.Id;
		let removedAssoc = associations?.contractAssoc?.length > 0 ? associations.contractAssoc.filter((item) => item !== addedAssoc).join(",") : "";
		if (associations?.contractAssoc?.length > 0 && associations.contractAssoc.some((item) => item === addedAssoc))
			addedAssoc = '';
		let docSubKind = await HelperFunctions.getMappedDocSubKind.bind(this)(rows[0].columns.Id);
		this.setState({
			prop_sx_docSubKind: docSubKind,
			assoc_sxcfc_contractAssoc_added: addedAssoc,
			assoc_sxcfc_contractAssoc_removed: removedAssoc
		});
		window.setTimeout(() => this.setState({ activeTab: documentTabs.information }), 100);
	}
}
export function rendercomments() {
	const { comments, prop_sys_node_uuid } = this.state;
	return (
		<div className="doc-form-block" key="commentsTab">
			{renderFormHeader.bind(this)()}
			<CommentsForm documentId={prop_sys_node_uuid} comments={comments} handleChangeComents={(comments) => this.setState({ comments: comments })} />
		</div>
	)
}

export function rendereditingRights() {
	const { performerInfo, prop_sxcfc_responsiblePerson, formMode, prop_sx_state, settings, isAdditionalSigningAllowed, isPerformer } = this.state;
	const tableItems = [];
	if (prop_sxcfc_responsiblePerson && performerInfo) {
		tableItems.push({
			columns: {
				Id: 0,
				FullName: performerInfo.fullName,
				Position: performerInfo.position,
				Email: prop_sxcfc_responsiblePerson
			}
		});
	}
	return (<div className="doc-form-block" key="editingRightsTab">
		{renderFormHeader.bind(this)()}
		<div className="doc-form col-lg-12">
			<br/>
			<label className="table-label">{i18n.t("responsiblePersone")}</label>
			<Table key="rightsTabTable" columns={settings.responsiblePersonTable.columns} items={tableItems} />
			<div className="form-group form-group__last">
				{(prop_sx_state === documentStatuses.project || prop_sx_state === documentStatuses.refinementCounterparty)
					&& JSON.parse(localStorage.getItem('user')).role === alfrescoRoles.MODERATOR
					&& formMode === formModes.read
					&& (isAdditionalSigningAllowed || !isPerformer)
					//isAdditionalSigningAllowed - means that we have more than one active user and it makes sence to show this button
					//when isAdditionalSigningAllowed == false, !isPerformer - means that current user is only one atcive user but the performer of this doc is deactivated and current user need this button to appoint themself as performer
					&& <button type="button" onClick={() => documentActionHandlerCallback.bind(this)(actionTypes.changeTaslExecuter)} className="btn btn-secondary">{i18n.t("13")}</button>
				}
			</div>
		</div>
	</div>);
}
export async function addMainFile(e) {
	e.persist();
	if (e.target.files && e.target.files.length > 0) {
		let errorMessage = CheckFunctions.getFileAttachmentErrorMessage(e.target.files[0], allowedMainFileExtensions, maxFileSize);
		if (errorMessage) {
			ModalDialog.showModalDialog("modalDialog", i18n.t("message"), "", <div className="info-message">{errorMessage}</div>, "feedPopup", true, [{ title: i18n.t("ok"), clickHandler: () => ModalDialog.hideModalDialog("modalDialog"), class: "btn-primary" }]);
			e.target.value = null;
		}
		else {
			let fileName = e.target.files[0]?.name;
			if (fileName) {
				let extension = fileName.split('.').slice(-1);
				if (extension && extension.length > 0 && extension[0].toLowerCase() === 'pdf') {
					const file = e.target.files[0];
					var b64 = (await HelperFunctions.getBase64(file, true))?.content;
					this.state.prop_cm_content = (await HelperFunctions.getBase64(file)).content;
					this.state.prop_sxcfc_documentName = fileName;
					this.state.prop_cm_content_extension = extension[0].toLowerCase();
					this.setState({
						mainB64Pdf: b64,
						mainDocuments: [{ id: (new Date().getTime()).toString(), file: file, fileName: fileName }]
					});
				}
				else
					ModalDialog.showModalDialog('modalDialog', i18n.t("error"), "", <div className="info-message">{i18n.t("badExtensionMessage")}</div>, "feedPopup", true, [{ title: i18n.t("ok"), clickHandler: () => ModalDialog.hideModalDialog('modalDialog'), class: "btn-primary" }]);
				e.target.value = null;
			}
		}
	}
}
export async function mainFileChanged(attachments) {
	if (attachments.length === 0) {
		this.setState({
			mainDocuments: attachments,
			prop_cm_content: '',
			prop_sxcfc_documentName: '',
			prop_cm_content_extension: '',
			mainB64Pdf: ''
		});
	}
	else {
		attachments = [attachments[0]];
		let fileName = attachments[0].fileName;
		if (fileName) {
			let extension = fileName.split('.').slice(-1);
			if (extension && extension.length > 0 && extension[0].toLowerCase() === 'pdf') {
				const file = attachments[0].file;
				var b64 = (await HelperFunctions.getBase64(file, true))?.content;
				this.state.prop_cm_content = (await HelperFunctions.getBase64(file)).content;
				this.state.prop_sxcfc_documentName = fileName;
				this.state.prop_cm_content_extension = extension[0].toLowerCase();
				this.setState({
					mainB64Pdf: b64,
					mainDocuments: [{ id: (new Date().getTime()).toString(), file: file, fileName: fileName }]
				});
			}
			else
				ModalDialog.showModalDialog('modalDialog', i18n.t("error"), "", <div className="info-message">{i18n.t("badExtensionMessage")}</div>, "feedPopup", true, [{ title: i18n.t("ok"), clickHandler: () => ModalDialog.hideModalDialog('modalDialog'), class: "btn-primary" }]);
		}
	}
}
export async function addFile(e) {
	e.persist();
	if (e.target.files && e.target.files.length > 0) {
		let errorMessage = CheckFunctions.getFileAttachmentErrorMessage(e.target.files[0], allowedAdditionalFileExtensions, maxFileSize);
		if (errorMessage) {
			ModalDialog.showModalDialog("modalDialog", i18n.t("message"), "", <div className="info-message">{errorMessage}</div>, "feedPopup", true, [{ title: i18n.t("ok"), clickHandler: () => ModalDialog.hideModalDialog("modalDialog"), class: "btn-primary" }]);
		}
		else {
			this.setState({
				additionalDocuments: [...this.state.additionalDocuments, {
					id: (new Date().getTime()).toString(),
					file: e.target.files[0],
					fileName: e.target.files[0]?.name,
					creatorFullName: this.context.userName,
					created: (new Date()).toISOString()
				}]
			});
		}
	}
	e.target.value = null;
}
export async function handleGetDocumentError(code, redirectUrl = '/') {
	switch (code) {
		case 401: History.push(urls.loginPageUrl); break;
		case 404: History.replace("/404"); break;
		case 403: return ModalDialog.showModalDialog('modalDialog', i18n.t("error"), "", <div className="info-message">{i18n.t("document403ErrorMessage")}</div>, "feedPopup", true, [{ title: i18n.t("ok"), clickHandler: () => { ModalDialog.hideModalDialog('modalDialog'); History.push(redirectUrl); }, class: "btn-primary" }], () => History.push(redirectUrl));
		case 406: return ModalDialog.showModalDialog('modalDialog', i18n.t("error"), "", <div className="info-message">{i18n.t("document406ErrorMessage")}</div>, "feedPopup", true, [{ title: i18n.t("ok"), clickHandler: () => { ModalDialog.hideModalDialog('modalDialog'); History.push(redirectUrl); }, class: "btn-primary" }], () => History.push(redirectUrl));
		case 500: return ModalDialogsTemplates.showLoader();
		default: ModalDialogsTemplates.unknownErrorMessageDialog(redirectUrl); break;
	}
}
export function additionalDocumentsCallback(attachments) {
	const { additionalDocuments, assoc_sx_additionalFiles_removed } = this.state;
	let removedItems = additionalDocuments.filter((curDoc) => attachments.filter((updateDoc) => updateDoc.nodeRef === curDoc.nodeRef).length === 0)
		.map(u => u.nodeRef).join(',');
	this.setState({
		assoc_sx_additionalFiles_removed: removedItems ? `${removedItems}${assoc_sx_additionalFiles_removed && "," + assoc_sx_additionalFiles_removed}` : assoc_sx_additionalFiles_removed,
		additionalDocuments: attachments
	});
}
export async function getXmlContent(id) {
	const response = await fetch('File/GetXml?docId=' + id);
	return response.ok ? await response.text() : '';
}
export async function signDocument(ids = []) {
	const { prop_sys_node_uuid, prop_cm_title, prop_sx_state, isLastSigner, currentStageSignatures, externalSigners, type, isMaxSignsCountAdded } = this.state;
	let currectStageExternalSigners = externalSigners?.filter(s => s.currentStageUser);

	let files = ids.map(item => ({ id: item }));
	files.push({ id: prop_sys_node_uuid, title: prop_cm_title, type: type, isMain: true });
	let currentObject = this;
	let handlerResult = function (isStamp = false) {
		let onClodeHandler = function () {
			ModalDialog.hideModalDialog('modalDialog');
			window.onbeforeunload = null;
			window.location.reload();
		}
		if ((prop_sx_state === documentStatuses.additionalSigningCounterparty || prop_sx_state === documentStatuses.signingCounterparty) && ((isLastSigner && currentStageSignatures?.length >= currectStageExternalSigners?.length && currentStageSignatures?.length > 0) || !isLastSigner)) {
			if (isStamp || (!isLastSigner && prop_sx_state === documentStatuses.additionalSigningCounterparty)) {
				//Set dateLoaded to undefined to avoid date creation check during submitting
				//If do not reset dateLoaded, date creation check will be failed because of modified date of document was updated during previous signing of this document
				currentObject.setState({ dateLoaded: undefined }, () => {
					handleSubmit.bind(currentObject)(prop_sx_state === documentStatuses.signingCounterparty ? documentBpActions.approve : documentBpActions.sign);
				});
			} else
				ModalDialog.showModalDialog('modalDialog', i18n.t("done"), "", <div className="info-message">{i18n.t("actionCompleteMessages.docSuccessfullySigned")}</div>, "feedPopup", true, [{ title: i18n.t("ok"), clickHandler: onClodeHandler, class: "btn-primary" }], onClodeHandler);
		}
		else {
			ModalDialog.showModalDialog('modalDialog', i18n.t("done"), "", <div className="info-message">{i18n.t("actionCompleteMessages.docSuccessfullySigned")}</div>, "feedPopup", true, [{ title: i18n.t("ok"), clickHandler: onClodeHandler, class: "btn-primary" }], onClodeHandler);
		}
	}
	let withoutStamp = isLastSigner ? currentStageSignatures?.filter(s => s.isMy).length === 0 : (prop_sx_state === documentStatuses.additionalSigningCounterparty || prop_sx_state === documentStatuses.signingCounterparty) && currentStageSignatures.length < currectStageExternalSigners.length;
	let withoutSign = isMaxSignsCountAdded;
	await signFiles.bind(this)(files, handlerResult, withoutStamp, withoutSign, isMaxSignsCountAdded);
}
export async function signDocumentWithAttachments() {
	const { attachments } = this.state;
	let ids = [];
	for (let i = 0; i < attachments?.length; ++i) {
		let { state, id } = attachments[i];
		if (state === attachmentStatuses.New || state === attachmentStatuses.Signed)
			ids.push(id);
	}
	await signDocument.bind(this)(ids);
}
export async function getFilesContentForSigning(files, ignoreErrors = false) {
	let fielesContent = [];
	let requestOptions = { method: 'post', headers: { 'Content-Type': 'application/json' } };
	for (let i = 0; i < files.length; ++i) {
		const response = await fetch("file/" + (files[i].type === alfrescoTypes.counterpartyAccreditationCard || files[i].type === alfrescoTypes.certificate ? "getXml" : "get") + `?nodeRefs=${files[i].id}`, requestOptions);
		if (response.ok) {
			let data = await response.json();
			if (data.length === 0 || data.some(item => item === null)) {
				return false;
			}
			let file = await HelperFunctions.urltoFile(`data:${data[0].mimeType};base64,${data[0].content}`, files[i].type !== alfrescoTypes.counterpartyAccreditationCard && files[i].type !== alfrescoTypes.certificate ? data[0].fileName : files[i].title + ".xml", data[0].mimeType);
			fielesContent.push({ id: files[i].id, value: file, file: data[0], info: files[i] });
		}
		else if (!ignoreErrors) return false;
	}
	return fielesContent;
}
export async function submitSignedFile(file, sign) {
	
	let base64SignFile = await HelperFunctions.getBase64(sign.value);	
	let fileName = mime.lookup(file.value.name) ? file.value.name : `${file.value.name}.${mime.extension(file.value.type)}`;
	let requestOptions = { method: 'post', headers: { 'Content-Type': 'application/json' } };

	requestOptions.body = JSON.stringify(Object.assign({
		properties: file.info.isMain ? null : { state: attachmentStatuses.Signed },
		currentElementNodeRef: `workspace://SpacesStore/${sign.id.split("/").pop()}`,
		elementType: file.info.isMain ? "cm:content" : (file.info.type === alfrescoTypes.certificate ? alfrescoTypes.certificateAdditionalDocument : alfrescoTypes.additionalDocument),
		assocName: file.info.isMain ? null : (file.info.type === alfrescoTypes.certificate ? alfrescoAssociations.certificateAdditionalDocuments : alfrescoAssociations.additionalDocuments),
		files: [
			{
				originalDocument: {
					content: file.file.content,
					fileName: fileName,
					mimeType: file.value.type
				},
				signedDocument: {
					content: base64SignFile.content,
					fileName: `${fileName}.p7s`,
					mimeType: base64SignFile.mimeType
				}
			}
		]
	}, {}));
	let response = await fetch(`File/${file.info.type === alfrescoTypes.counterpartyAccreditationCard || file.info.type === alfrescoTypes.certificate ? 'AddAttachment' : 'EditAttachment'}`, requestOptions);
	return response.ok;
}
export async function signFiles(files = [], handlerResult = null, withoutStamp = false, withoutSign = false, isMaxSignsCountAdded = false) {
	let fielesContent = await getFilesContentForSigning(files);
	if (!fielesContent) {
		return require('../ModalDialogsTemplates').unknownErrorMessageDialog();
	}
	let onSignHandler = async function (signs, isStamp = false) {
		if (await checkActionPermission.bind(this)("Sign")) {
			for (let j = 0; j < signs.length; ++j) {
				let file = fielesContent.find(item => item.id === signs[j].id);
				let result = await submitSignedFile(file, signs[j]);
				if (!result) {
					require('../ModalDialogsTemplates').unknownErrorMessageDialog();
				}
			}
			if (handlerResult) handlerResult(isStamp);
		}
	}
	let handlerCloseDialog = function () {
		if (handlerResult) handlerResult(false);
		ModalDialog.hideModalDialog('modalDialog');
	}
	let handlerRestart = function () {
		if (handlerResult) handlerResult(false);
		signFiles.bind(this)(files, handlerResult, withoutStamp, withoutSign, isMaxSignsCountAdded);
	}

	const stampIsRequired = this.state.prop_sxcfc_stampIsRequired;

	ModalDialog.showModalDialog('modalDialog', i18n.t("digitalSignature"), "",
		<SignForm
			files={fielesContent}
			handlerRestart={handlerRestart.bind(this)}
			onSignHandler={onSignHandler.bind(this)}
			onCloseHandler={() => {
				ModalDialog.hideModalDialog('modalDialog'); handlerResult(false);
			}}
			withoutStamp={withoutStamp}
			withoutSign={withoutSign}
			maxSignsCountAdded={isMaxSignsCountAdded}
			stampIsRequired={stampIsRequired}
		/>,
		"feedPopup middle-size", true, [], handlerCloseDialog);
}
export async function startDocumentActopnReject(action) {
	const currentObject = this;
	let rejectConfirmDialog = function () {
		currentObject.actionHandlerCallback(actionTypes.save, action);
	}
	ModalDialog.showModalDialog('modalDialog', i18n.t("attentionTitle"), "", <div className="info-message">{i18n.t("rejectDocumentMessage")}</div>, "feedPopup", true, [{ title: i18n.t("yes"), clickHandler: rejectConfirmDialog, class: "btn-primary" }, { title: i18n.t("no"), clickHandler: () => { ModalDialog.hideModalDialog('modalDialog') }, class: "btn-secondary" }]);
}
export async function checkDocumentSigns() {
	const { attachments, attachmentsTypes, type, prop_sys_node_uuid } = this.state;
	let ids = attachments.filter(at => at.signs !== null && at.signs?.length > 0).map((item) => Object.assign(item, { documentTypeValue: attachmentsTypes?.filter(type => type.value === item.documentType)[0]?.title })).map((item) => item.nodeRef);
	checkSigns.bind(this)(ids.concat([prop_sys_node_uuid]), type === alfrescoTypes.counterpartyAccreditationCard || type === alfrescoTypes.certificate ? i18n.t("xmlDocumentTypeValue") : "");
}
export async function checkSigns(ids, documentTypeValue = " ") {
	const prop_sys_node_uuid = this?.state?.prop_sys_node_uuid;
	let withSignatures = (await Promise.all(ids.map(async (item) => await fetch(`File/GetSignatures/${item.split('/').pop()}`)
		.then(async (response) => {
			if (!response.ok) {
				require('../ModalDialogsTemplates').unknownErrorMessageDialog();
				return null;
			}
			else return {
				signs: (await response.json())?.signatures, documentTypeValue: prop_sys_node_uuid === item.split('/').pop() ? documentTypeValue : ""
			};
		}))))?.filter(item => item.signs?.length > 0);
	if (withSignatures) {
		ModalDialog.showModalDialog('modalDialog', i18n.t("listOfSignatures"), "", <CheckSignsForm signedFiles={withSignatures} docId={prop_sys_node_uuid} />, "feedPopup check-signs-dialog", true, [{ title: i18n.t("ok"), clickHandler: () => ModalDialog.hideModalDialog('modalDialog'), class: "btn-primary" }], null, [{ src: '/img/icn-refresh.svg', onClickCallback: () => checkSigns.bind(this)(ids, documentTypeValue) }]);
	}
}
function onCheckFailedMessageClose() {
	if (this.state.type === alfrescoTypes.counterpartyAccreditationCard)
		this.navigateToIncorrectForm.bind(this)();
	else
		this.setState({ activeTab: documentTabs.information });
	if (this.mutualSettlementDataError) {
		globalEventDispatcher.dispatch(dispatcherActionTypes.onShowMutualSettlementDataError);
	}
}
function showCheckFailedMessage() {
	const { type } = this.state;
	const currentObject = this;
	let messageText = '';

	if (this.checkErrorText) {
		messageText = this.checkErrorText;
	}
	else if (type === alfrescoTypes.counterpartyAccreditationCard && this.incorectTabs && this.incorectTabs.length > 0
		&& this.incorectTabs[0] === documentTabs.signers) {
		messageText = i18n.t("fillSignersInfoMessage");
	} else {
		messageText = this.incorrectFormat ? i18n.t("notAllFildsWithCorrectFormatMessage") : i18n.t("notAllRequiredFildsAreSpecifiedMessage");
	}
	ModalDialog.showModalDialog('modalDialog', i18n.t("attentionTitle"), "",
		<div className="info-message">{messageText}</div>,
		"feedPopup", true,
		[{ title: i18n.t("ok"), clickHandler: () => { ModalDialog.hideModalDialog('modalDialog'); onCheckFailedMessageClose.bind(currentObject)(); }, class: "btn-primary" }],
		() => onCheckFailedMessageClose.bind(currentObject)()
	);
}
export async function documentActionHandlerCallback(actionType, actionRequest) {
	const { type, prop_sys_node_uuid, associations } = this.state;
	let currentObject = this;
	this.setState({ submitted: true });
	// eslint-disable-next-line default-case
	switch (actionType) {
		case actionTypes.cancel: handlerCloseDocument.bind(this)(); break;
		case actionTypes.edit:
			if (await checkActionPermission.bind(this)("Edit")) {
				History.push(window.location.pathname.toLowerCase().replace(formModes.read.toLowerCase(), formModes.edit.toLowerCase()) + window.location.search);
			}
			break;
		case actionTypes.changeTaslExecuter:
			if (await checkActionPermission.bind(this)("ChangeExecuter")) {
				ModalDialog.showModalDialog("loadingDialog", i18n.t("14"), "", <ListOfAlfresco companyName={this.context.companies[0].companyShortName} saveApi={`Table/Save?searchTableTypes=${searchTableTypes.Users}`} prop_sys_node_uuid={prop_sys_node_uuid} parentComponent={ListOfUsersTaskExecuters} type={searchTableTypes.Users} />, "feedPopup middle-size");
			}
			break;
		case actionTypes.reject: startDocumentActopnReject.bind(this)(actionRequest); break;
		case actionTypes.save:
			handleSubmit.bind(this)(actionRequest ? actionRequest : "");
			break;
		case actionTypes.annul:
			let annulConfirmDialog = function () {
				currentObject.actionHandlerCallback(actionTypes.save, actionRequest);
			}
			ModalDialog.showModalDialog('modalDialog', i18n.t("attentionTitle"), "", <div className="info-message">{i18n.t("cancelDocumentMessage")}</div>, "feedPopup", true, [{ title: i18n.t("yes"), clickHandler: annulConfirmDialog, class: "btn-primary" }, { title: i18n.t("no"), clickHandler: () => { ModalDialog.hideModalDialog('modalDialog') }, class: "btn-secondary" }]);
			break;
		case actionTypes.additionalSign:
			if (this.checkInputPage()) {
				if ((type !== alfrescoTypes.counterpartyAccreditationCard && type !== alfrescoTypes.simpleCounterpartyAccreditationCard && type !== alfrescoTypes.certificate) || this.checkAttachmentsMandatoryAdding()) {
					ModalDialog.showModalDialog('modalDialog', i18n.t("additionalSignatories"), "",
						<AddSignatoryForm
							companyName={this.context.companies[0].companyShortName}
							handleAddSignatory={(id) => addAdditionaSignatory.bind(this)(id, actionRequest)}
							handleFormClose={() => ModalDialog.hideAllDialogs()}
						/>,
						"feedPopup middle-size");
				}
				else {
					ModalDialog.showModalDialog('modalDialog', i18n.t("attentionTitle"), "", <div className="info-message">{i18n.t("notAllFilesAdded")}</div>, "feedPopup", true,
						[{
							title: i18n.t("ok"), clickHandler: () => {
								currentObject.setState({ activeTab: type === alfrescoTypes.counterpartyAccreditationCard ? documentTabs.docs : documentTabs.information });
								ModalDialog.hideModalDialog('modalDialog');
							}, class: "btn-primary"
						}], () => {
							currentObject.setState({ activeTab: type === alfrescoTypes.counterpartyAccreditationCard ? documentTabs.docs : documentTabs.information });
						});
				}
			}
			else
				showCheckFailedMessage.bind(this)();
			break;
		case actionTypes.sign:
			if (await checkActionPermission.bind(this)("Sign")) {
				if (type === alfrescoTypes.counterpartyAccreditationCard || type === alfrescoTypes.simpleCounterpartyAccreditationCard || type === alfrescoTypes.certificate) {
					if (this.checkInputPage()) {
						if (this.checkAttachmentsMandatoryAdding())
							signDocumentWithAttachments.bind(this)();
						else
							ModalDialog.showModalDialog('modalDialog', i18n.t("attentionTitle"), "", <div className="info-message">{i18n.t("notAllFilesAdded")}</div>, "feedPopup", true,
								[{
									title: i18n.t("ok"), clickHandler: () => {
										currentObject.setState({ activeTab: type === alfrescoTypes.counterpartyAccreditationCard ? documentTabs.docs : documentTabs.information });
										ModalDialog.hideModalDialog('modalDialog');
									}, class: "btn-primary"
								}], () => {
									currentObject.setState({ activeTab: type === alfrescoTypes.counterpartyAccreditationCard ? documentTabs.docs : documentTabs.information });
								});
					}
					else
						showCheckFailedMessage.bind(this)();
				}
				else if (associations?.contractAssoc?.length === 0)
					require('../ModalDialogsTemplates').messageDialog(i18n.t("message"), i18n.t("3"));
				else if (this?.checkInputPage(true))
					signDocument.bind(this)();
				else
					showCheckFailedMessage.bind(this)();
			}
			break;
	}
}
export async function checkActionPermission(actionName) {
	const { prop_sys_node_uuid, dateLoaded } = this.state;
	let result = await fetch(`Document/CheckActionPermission?id=${prop_sys_node_uuid}&actionName=${actionName}&loadedDate=${dateLoaded}`, { method: "GET" })
		.then(async (res) => {
			const data = await res.json();
			let modalCloseFunction = async function () {
				window.onbeforeunload = null;
				document.location.replace(`/document/${formModes.read}/${prop_sys_node_uuid}`);
			}
			if (!data.success) {
				ModalDialogsTemplates.messageDialog(i18n.t("error"), data.errorMessage, () => modalCloseFunction());
			}
			return data.success;
		});
	return result;
}
export async function deleteDocument(id) {
	await fetch(`Document/Delete?id=${id}`, { method: "DELETE" })
		.then(res => {
			if (!res.ok) require('../ModalDialogsTemplates').unknownErrorMessageDialog();
		});
}
export function buildFormSection(sectionName) {
	const { form, submitted, prop_sx_docKind, type } = this.state;
	let formMode = this.state.formMode;
	if (type === alfrescoTypes.outgoingDocument && prop_sx_docKind === outgoingDocumentKinds.mutualSettlementsAct) {
		formMode = formModes.read;
	}
	let section = getFormSection(form, sectionName);
	let sectionSettings = getFormSectionSettings(form, sectionName);
	let sectionItems = section.sectionItems;
	if (sectionItems) {
		let fields = [];
		for (let i = 0; i < sectionItems.length; ++i) {
			let item = JSON.parse(JSON.stringify(sectionItems[i]));
			if (item?.Name) item.Value = this.state[item.Name];
			item = this.buildFormItem.bind(this)(item);
			if (item) fields.push(item);
			else if (item?.Type === formFieldTypes.select && !this.state[item.Name]) {
				item.Value = this.state[item.Name] = item.Values.Data[0].Value;
			}
			let indexFieldConfiguration = form.Fields.findIndex((field) => field.Name === item?.Name);
			if (indexFieldConfiguration !== -1) {
				form.Fields[indexFieldConfiguration].Ignore = fields.findIndex((field) => field?.Name === item?.Name) === -1 || item?.Type === formFieldTypes.empty;
				item.Disabled = formMode === formModes.read ? true : item.Disabled;
				item.Check = submitted/* || formModes.edit === formMode*/;
			}
		}
		return (
			<>
				{sectionSettings?.Label?.Label ? <div className="form-group col-sm-12 col-xs-12">
					<label className="header-label">{sectionSettings?.Label?.Label}</label>
				</div> : ""}
				{fields.map((item) =>
					<div key={item?.Name} name={item.Name} className={'form-group col-sm-' + item.Columns + ' col-xs-' + item.Columns} >
						{<InputContainer {...item}>{buildFormField(item, HelperFunctions.changeInputValue.bind(this))}</InputContainer>}
					</div>
				)}
			</>
		);
	}
	return ([]);
}
export function setLocalStorage() {
	const { prop_sys_node_uuid, prop_sx_state, formMode, type, prop_sx_docKind, prop_sxcfc_remark } = this.state;
	if (formMode === formModes.edit) {
		if (prop_sx_state === documentStatuses.project || (
			(type === alfrescoTypes.outgoingDocument &&
				(prop_sx_state === documentStatuses.performingCounterparty || prop_sx_state === documentStatuses.refinementCounterparty) &&
				prop_sx_docKind === outgoingDocumentKinds.mutualSettlementsAct)
		)) {
			fetch(`Document/GetCashe?key=${prop_sys_node_uuid}`, { method: "get" })
				.then(async (response) => {
					if (response.ok) {
						let text = await response.text();
						let storage = text ? JSON.parse(text) : localStorage.getItem(prop_sys_node_uuid);
						if (storage) {
							if (prop_sx_state === documentStatuses.project && storage !== "{}" && Object.keys(storage).length > 0) {
								this.setState(storage);
							}
							else if (type === alfrescoTypes.outgoingDocument &&
								(prop_sx_state === documentStatuses.performingCounterparty || prop_sx_state === documentStatuses.refinementCounterparty) &&
								prop_sx_docKind === outgoingDocumentKinds.mutualSettlementsAct &&
								storage.mutualSettlementCashedData) {
								this.setState({
									mutualSettlementCashedData: storage.mutualSettlementCashedData,
									prop_sxcfc_remark: prop_sxcfc_remark
								});
							}
						}
					}
				});
		}
	}
}
export function updateServerStorage() {
	const { prop_sys_node_uuid, form, prop_sx_state, type, prop_sx_docKind } = this.state;

	if (prop_sx_state === documentStatuses.project || (
		(type === alfrescoTypes.outgoingDocument &&
			(prop_sx_state === documentStatuses.performingCounterparty || prop_sx_state === documentStatuses.refinementCounterparty) &&
			prop_sx_docKind === outgoingDocumentKinds.mutualSettlementsAct)
	)) {
		console.log('updateServerStorage started');
		let storage = JSON.stringify(Object.assign({ mutualSettlementCashedData: this.state.mutualSettlementData }, ...form.Fields.filter(item => item.Name && item.Name !== "prop_sxcfc_hasAccountant").map((item) => ({ [item.Name]: this.state[item.Name] }))));

		fetch(`Document/SetCashe`, {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({ key: prop_sys_node_uuid, value: storage })
		}).then((response) => {
			if (!response.ok) localStorage.setItem(prop_sys_node_uuid, storage);
		});
	}
}
export function renderAdditionalCounterparties() {
	const { additionalCounterparties, settings } = this.state;
	if (additionalCounterparties?.additionalCounterpartiesInfo?.length > 0) {
		let tableItems = [];
		if (additionalCounterparties.mainCounterpartyInfo) {
			let item = additionalCounterparties.mainCounterpartyInfo;
			item.IPN_EDRPOUCode = item.codeEDRPOU ?? item.codeIPN;
			item.Id = 0;
			tableItems.push({
				columns: item
			});
		}
		let id = 1;
		additionalCounterparties.additionalCounterpartiesInfo.forEach(item => {
			item.IPN_EDRPOUCode = item.codeEDRPOU ?? item.codeIPN;
			item.Id = id;
			tableItems.push({
				columns: item
			});
			id++;
		});
		return <div className="additional-counterparties">
			<div className="col-lg-12">
				<label className="table-label">{i18n.t("additionalCounterparties")}</label>
				<Table key="additionalCounterpartiesTable" columns={settings.additionalCounterpartiesTable.columns} items={tableItems} disableSelection={true} />
			</div>
		</div>;
	}
	return "";
}
export function rendersigners() {
	const { formMode, externalSigners, signers, settings, type, submitted } = this.state;
	for (let i = 0; i < signers?.length; ++i) {
		signers[i].actions = [{ isMultiaction: false, title: i18n.t("view"), type: actionTypes.preview }];
		if (formMode !== formModes.read) {
			signers[i].actions.push({ btnClass: "btn-secondary", isMultiaction: false, title: i18n.t("edit"), type: actionTypes.edit });
			signers[i].actions.push({ btnClass: "btn-no-fill", isMultiaction: true, title: i18n.t("remove"), type: actionTypes.remove });
		}
	}
	return (
		<div className="doc-form-block" key="signersTab">
			{renderFormHeader.bind(this)()}
			{type === alfrescoTypes.counterpartyAccreditationCard ?
				<div>
					<SubTabs tabs={settings.tabs.find((tab) => tab.name === documentTabs.signers)?.tabs}>
						<SignersTableForm signers={signers} handleAddSigner={this.addUser.bind(this)} handleDeleteSigners={this.deleteSigners.bind(this)} />
						<ExternalSigners signers={externalSigners} />
					</ SubTabs>
					{submitted && (!signers || signers.length === 0) &&
						<div className="col-lg-12">
							<div className="help-block signers-help-block">{i18n.t("requiredField")}</div>
						</div>
					}
				</div>
				:
				<ExternalSigners signers={externalSigners} />}
		</div>
	);
}
export function renderFormHeader() {
	const { prop_cm_title, prop_sys_node_uuid, formMode, prop_sx_states, isCretor, prop_sx_state, prop_cm_created, creatorInfo, performerInfo, isPerformer, type, settings, signatures, user, signers, isAdditionalSigningAllowed, isEditAllowed, isLastSigner, prop_sxcfc_stampIsRequired, prop_sx_docKind } = this.state;
	let fillFromCallback = (actionType, ids) => {
		// eslint-disable-next-line default-case
		switch (actionType) {
			case actionTypes.add:
				this.getForm(ids[0]);
				ModalDialog.hideModalDialog('modalDialog');
				break;
		}
	}
	let btns = {
		download: { src: "icn-download.svg", key: "download", title: i18n.t("download"), onClick: () => downloadFile(prop_sys_node_uuid, prop_cm_title + " " + user.companyShortName.replaceAll(`"`, `''`), type) },
		downloadWithSign: { src: "icn-sign1.svg", key: "downloadWithSign", title: i18n.t("downloadWithSignatures"), onClick: () => downloadFile(prop_sys_node_uuid, "", "", true) },
		checkSign: { src: "check.svg", key: "checkSign", title: i18n.t("checkSignatures"), onClick: checkDocumentSigns.bind(this) },
		downloadTemplate: { src: "icn-download.svg", key: "downloadTemplate", title: i18n.t("downloadTemplate"), onClick: () => ModalDialog.showModalDialog('modalDialog', i18n.t(i18n.t("downloadDocumentTemplate")), "", <StatutoryDocsForm key={statutoryDocTypes.template} docType={statutoryDocTypes.template} canEdit={false} inPopup={false} />, "feedPopup middle-size") },
		newConnection: { src: "sep.svg", key: "newConnection", title: i18n.t("addConnection"), onClick: () => ModalDialog.showModalDialog('modalDialog', i18n.t("addNewConnection"), "", <ListOfAlfresco typeOfMenu={menuTypes.WithoutMenu} parentComponent={ListOfContracts} withAction={false} type={searchTableTypes.Documents} additionalFilter={[{ "DocType": [docTypes.contract, docTypes.outgoingDocument, docTypes.sourcedocument, docTypes.certificate] }]} actionHandlerCallback={handleChangeRelatedDocuments.bind(this)} />, "feedPopup middle-size") },
		addComment: { src: "icn-comadd.svg", key: "addComment", title: i18n.t("addComment"), onClick: () => ModalDialog.showModalDialog('modalDialog', i18n.t("addComment"), "", <CommentForm withFiles={true} documentId={prop_sys_node_uuid} handleChangeComment={addComment.bind(this)} onCloseHandler={() => { ModalDialog.hideModalDialog('modalDialog'); }} />, "feedPopup") },
		getComents: { classes: "has-additionnal-btn", key: "getComents", src: "icn-refresh.svg", title: i18n.t("update"), onClick: getComents.bind(this) },
		youControlRequest: { src: "refresh.svg", key: "youControlRequest", title: i18n.t("fillWithYouControl"), onClick: this.youControlRequest },
		transliterate: { src: "transliteration.svg", key: "transliterate", title: i18n.t("fieldsTransliteration"), onClick: this.transliterate },
		addSigner: { src: "users.svg", key: "addSigner", title: i18n.t("addSignatory"), onClick: () => { this.addSigner(false); } },
		addAccountant: { src: "users.svg", key: "addAccountant", title: i18n.t("addAccountant"), onClick: () => { this.addSigner(true); } },
		addAttacment: {
			src: "icn-addatach.svg", key: "addAttacment", title: i18n.t("addDocument"),
			onClick: () => ModalDialog.showModalDialog('modalDialog', i18n.t("addDocument"), "",
				<AttachmentForm typesOfDocumens={this.getCurAttacmentsTypes()} handleAddDocument={this.addAttacment.bind(this)} onCloseHandler={() => { ModalDialog.hideModalDialog('modalDialog'); }} />, "feedPopup middle-form")
		},
		fillFrom: { src: "refresh.svg", key: "fillFrom", title: i18n.t("17"), onClick: () => ModalDialog.showModalDialog('modalDialog', i18n.t("17"), "", <ListOfAlfresco typeOfMenu={menuTypes.WithoutMenu} actionHandlerCallback={fillFromCallback.bind(this)} saveApi={`Table/Save?searchTableTypes=${searchTableTypes.Requests}`} parentComponent={ListOfDocuments} additionalFilter={{ "Type": ["4"]/*, "Status": ["Rejected Cofco", "Canceled Counterparty", "Confirmed Cofco"]*/ }} type={searchTableTypes.Requests} withAction={false} actionsForAll={[{ "title": i18n.t("15"), "type": actionTypes.add, "isMultiaction": false, "btnClass": "btn-primary", "sortIndex": -1 }]} />, "feedPopup middle-size") },
	};
	let tabName = HelperFunctions.getUrlParam("tab")?.toLowerCase();
	let activeBtns = documentTabs.comments === tabName ? [btns.addComment] : [];
	// eslint-disable-next-line default-case
	switch (formMode) {
		case formModes.create:
		case formModes.edit:
			if (type === alfrescoTypes.counterpartyAccreditationCard) {
				if (documentTabs.docs === tabName) activeBtns.push(btns.addAttacment, btns.downloadTemplate);
				else if (documentTabs.signers === tabName) {
					activeBtns.push(btns.addSigner);
					if (!signers || !signers.some(s => s.columns.IsAccountant))
						activeBtns.push(btns.addAccountant);
					activeBtns.push(btns.youControlRequest);
				}
				else if (documentTabs.information === tabName || !tabName) activeBtns.push(btns.youControlRequest, btns.transliterate);
				else activeBtns.push(btns.youControlRequest);
			}
			else if (!(type === alfrescoTypes.outgoingDocument && prop_sx_docKind === outgoingDocumentKinds.reconciliationAct)) activeBtns.push(btns.downloadTemplate);
			break;
		case formModes.read:
			activeBtns.push(btns.download, btns.downloadWithSign, btns.checkSign);
			if (documentTabs.connections === tabName && isEditAllowed) activeBtns.splice(1, 0, btns.newConnection);
			break;
	}
	if (type === alfrescoTypes.counterpartyAccreditationCard) activeBtns.push(btns.fillFrom);
	if (documentTabs.comments === tabName && formMode !== formModes.create) activeBtns.push(btns.getComents);

	let companyId = JSON.parse(localStorage?.getItem('user'))?.companies[0]?.id;
	let validSignatures = signatures?.filter((s) => s.state === signatureStates.signed && s.isPortalSignature &&
		(s.signatureCounterparty === null || s.signatureCounterparty === '' || s.signatureCounterparty.endsWith(companyId)));

	let actions = settings.actions.filter(item => (
		item.type === actionTypes.cancel ||
		(
			(
				isPerformer &&
				(
					isCretor ||
					(
						prop_sx_state !== documentStatuses.project &&
						(prop_sx_state !== documentStatuses.refinementCounterparty || (type === alfrescoTypes.outgoingDocument && (prop_sx_docKind === outgoingDocumentKinds.reconciliationAct || prop_sx_docKind === outgoingDocumentKinds.mutualSettlementsAct)))
					)

				) &&
				(item?.statuses?.includes(prop_sx_state) || item?.statuses?.includes(documentStatuses.All)) &&
				(item?.modes?.includes(formMode) || item?.modes?.includes(formModes.all))
			) &&
			(!item?.excludedStatuses || item.excludedStatuses.length === 0 || !item.excludedStatuses.includes(prop_sx_state)) &&
			(!item?.kinds || item.kinds.length === 0 || item.kinds.includes(prop_sx_docKind)) &&
			(!item?.excludedKinds || item.excludedKinds.length === 0 || !item.excludedKinds.includes(prop_sx_docKind)) &&
			!(
				(item.type === actionTypes.additionalSign || item.type === actionTypes.sign) &&
				(prop_sx_state === documentStatuses.project || prop_sx_state === documentStatuses.refinementCounterparty || prop_sx_state === documentStatuses.additionalSigningCounterparty) &&
				validSignatures?.length > 1 &&
				validSignatures.filter(s => !!s.subjEdrpou && !s.subjDrfo).length > 0
			)
		)
	));
	if (!isAdditionalSigningAllowed) {
		actions = actions.filter(item => item.type !== actionTypes.additionalSign);
	}
	if (prop_sx_state === documentStatuses.additionalSigningCounterparty) {
		if (validSignatures?.filter(s => s.isMy)?.length <= 0 || (prop_sxcfc_stampIsRequired && validSignatures?.filter(s => !!s.subjEdrpou && !s.subjDrfo).length <= 0)) {
			actions = actions.filter(item => item.action !== documentBpActions.send && item.action !== documentBpActions.approve);
		}
		if (!isLastSigner && validSignatures?.filter(s => s.isMy)?.length > 0) {
			actions = actions.filter(item => item.type !== actionTypes.sign);
		}
	}
	if (type === alfrescoTypes.outgoingDocument && prop_sx_docKind === outgoingDocumentKinds.reconciliationAct) {
		actions = actions.filter(item => item.action !== documentBpActions.refinement);
	}
	return (
		<>
			<div className="buttons-block-header">
				<ul>
					{actions.map((item, index) => (
						<li key={index}>
							<button onClick={() => { if (item?.type) this.actionHandlerCallback(item.type, item.action) }}
								className={"btn " + (index === 0 && actions.length !== 1 ? "btn-primary" : (item.btnClass ? item.btnClass : "btn-primary"))}>
								{item.title}
							</button>
						</li>
					))}
					<DocumentInfo creatorInfo={creatorInfo} performerInfo={performerInfo} created={prop_cm_created} state={prop_sx_state} states={prop_sx_states} formMode={formMode} />
				</ul>
			</div>
			<div style={{ display: activeBtns.length > 0 ? "" : "none" }} className="filter-block-header">
				<ul className="filter-header-buttons">
					{activeBtns.map((item, index) =>
						<li key={formMode + tabName + index + item.key ?? ""} className={item.classes ?? ""}>
							<button type="button" className="btn no-bg-btn" onClick={item.onClick}><Svg src={`/img/${item.src}`} /><span>{item.title}</span></button>
						</li>)}
				</ul>
			</div>
		</>
	);
}
export async function handleSubmit(action) {
	const { additionalDocuments, attachments, prop_sys_node_uuid, signers, type, comments, dateLoaded, prop_sxcfc_stampIsRequired, prop_sx_state, prop_sx_docKind, mutualSettlementData } = this.state;
	let requestAction = action;
	if (action === documentBpActions.annul) requestAction = documentBpActions.reject;
	if (action === documentBpActions.sign) requestAction = documentBpActions.approve;
	if (action === documentBpActions.addConnection) requestAction = "";
	let message;
	switch (action) {
		case documentBpActions.send:
		case documentBpActions.approve: message = i18n.t("actionCompleteMessages.docSuccessfullySended"); break;
		case documentBpActions.sign: message = i18n.t("actionCompleteMessages.docSuccessfullySigned"); break;
		case documentBpActions.reject: message = i18n.t("actionCompleteMessages.docSuccessfullyRejected"); break;
		case documentBpActions.annul: message = i18n.t("actionCompleteMessages.docSuccessfullyAnnuled"); break;
		case documentBpActions.refinement: message = i18n.t("actionCompleteMessages.docSuccessfullySendedToRefinement"); break;
		case documentBpActions.additionalSigning:
		case documentBpActions.toAdditionalSigning: message = i18n.t("actionCompleteMessages.docSuccessfullySendedToAdditionalSigner"); break;
		default: message = i18n.t("actionCompleteMessages.docSuccessfullySaved");
	}

	let currentObject = this;

	const doAction = async function () {
		var checkSignedResult;
		if ((type === alfrescoTypes.counterpartyAccreditationCard || type === alfrescoTypes.simpleCounterpartyAccreditationCard || type === alfrescoTypes.certificate) && action === documentBpActions.approve) {
			let message = !currentObject.checkAttachmentsMandatoryAdding() ? i18n.t("notAllFilesAdded") : (!currentObject.checkAttachmentsMandatorySigning() ? i18n.t("notAllFilesSigned") : "");
			if (message) {
				ModalDialog.showModalDialog('modalDialog', i18n.t("attentionTitle"), "", <div className="info-message">{message}</div>, "feedPopup", true,
					[{
						title: i18n.t("ok"), clickHandler: () => {
							currentObject.setState({ activeTab: type === alfrescoTypes.counterpartyAccreditationCard ? documentTabs.docs : documentTabs.information });
							ModalDialog.hideModalDialog('modalDialog');
						}, class: "btn-primary"
					}], () => {
						currentObject.setState({ activeTab: type === alfrescoTypes.counterpartyAccreditationCard ? documentTabs.docs : documentTabs.information });
					});
				return;
			}
			else if (type === alfrescoTypes.counterpartyAccreditationCard || type === alfrescoTypes.certificate) {
				checkSignedResult = await CheckFunctions.checkFileIsSigned(prop_sys_node_uuid);
				if (!checkSignedResult.signed) {
					if (checkSignedResult.error)
						require('../ModalDialogsTemplates').unknownErrorMessageDialog();
					else
						ModalDialog.showModalDialog('modalDialog', i18n.t("attentionTitle"), "", <div className="info-message">{i18n.t("needToSignXmlMessage")}</div>, "feedPopup", true, [{ title: i18n.t("ok"), clickHandler: () => { ModalDialog.hideModalDialog('modalDialog') }, class: "btn-primary" }]);
					return;
				}
			}
		}
		if ((action === documentBpActions.approve || action === documentBpActions.send) && prop_sx_state !== documentStatuses.familiarizationCounterparty
			&& !(type === alfrescoTypes.outgoingDocument && (prop_sx_state === documentStatuses.processingCounterparty || prop_sx_state === documentStatuses.refinementCounterparty))) {
			if (await checkActionPermission.bind(currentObject)(requestAction)) {
				checkSignedResult = await CheckFunctions.checkFileIsSigned(prop_sys_node_uuid);
				if (checkSignedResult.length > 0 && (prop_sxcfc_stampIsRequired && !checkSignedResult.withStamp)) {
					return require('../ModalDialogsTemplates').errorMessageDialog(i18n.t("0"));
				}
				else if (!checkSignedResult.signed) {
					if (checkSignedResult.error) require('../ModalDialogsTemplates').unknownErrorMessageDialog();
					else ModalDialog.showModalDialog('modalDialog', i18n.t("attentionTitle"), "", <div className="info-message">{i18n.t("needToSignContractMessage")}</div>, "feedPopup", true, [{ title: i18n.t("ok"), clickHandler: () => { ModalDialog.hideModalDialog('modalDialog') }, class: "btn-primary" }]);
					return;
				}
			}
			else return;
		}
		let props = getFormFields(currentObject.state.form, currentObject.state);
		let additionalFiles = [];
		for (let i = 0; i < additionalDocuments.length; ++i) {
			if (!additionalDocuments[i].nodeRef) {
				additionalFiles.push({ fileName: additionalDocuments[i].fileName, extension: `.${mime.extension(mime.lookup(additionalDocuments[i].fileName))}`, content: (await HelperFunctions.getBase64(additionalDocuments[i].file)).content });
			}
		}
		let signatories = signers.map(item => item.columns);
		let documentAttachments = [];
		if (type === alfrescoTypes.counterpartyAccreditationCard || type === alfrescoTypes.simpleCounterpartyAccreditationCard || type === alfrescoTypes.certificate) {
			for (let i = 0; i < attachments.length; ++i) {
				if (attachments[i].state !== attachmentStatuses.NotAdded && currentObject.getCurAttacmentsTypes()?.some((item) => item?.value === attachments[i].documentType)) {
					let { file, content, signs } = attachments[i];
					documentAttachments.push({ currentElementNodeRef: attachments[i].nodeRef, properties: {}, files: null });
					Object.keys(attachments[i]).forEach(function (key) {
						documentAttachments[documentAttachments.length - 1].properties[key] = attachments[i][key];
					});
					if (!file && attachments[i].nodeRef) content = await getFile(attachments[i].nodeRef);
					if (file || content) {
						let base64File = file ? await HelperFunctions.getBase64(file) : null;
						let signFile = signs?.length > 0 ? attachments[i]?.signs[0] : null;
						let fileName = attachments[i].title;
						if (content)
							content.fileName = fileName;
						documentAttachments[documentAttachments.length - 1].files = [{
							originalDocument: (base64File ? {
								content: base64File.content,
								fileName: fileName,
								mimeType: base64File.mimeType
							} : content), signedDocument: signFile ? signFile.content : null
						}];
					}
				}
			}
		}
		if (!props.prop_cm_content_extension)
			props.prop_cm_content_extension = props.prop_sxcfc_documentName = props.prop_cm_content = '';
		const save = async function (comment) {
			fetch(`Document/${prop_sys_node_uuid ? "Update" : "Add"}/${prop_sys_node_uuid ?? ''}${requestAction ? `?actionDoc=${requestAction}` : ""}`, {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({
					properties: JSON.stringify(props),
					comments, additionalFiles,
					additionalDocuments: documentAttachments,
					signatories, comment: comment?.content ? comment.content : "", type,
					dateLoaded,
					mutualSettlementData
				})
			})
				.then(async (response) => {
					if (response.status === 422) require('../ModalDialogsTemplates').errorMessageDialog(i18n.t("4"));
					else if (!response.ok) handleGetDocumentError(response.status);
					else {
						const data = await response.json();
						let modalCloseFunction = async function () {
							if (data.checkResult.success && (action === documentBpActions.approve || action === documentBpActions.send)) {
								window.onbeforeunload = null;
								document.location.replace('/');
							}
							else {
								if (prop_sys_node_uuid) {
									window.onbeforeunload = null;
									document.location.replace(`/document/${formModes.read}/${prop_sys_node_uuid}`);
								}
								else if (data.alfrescoResponse.itemId) {
									window.onbeforeunload = null;
									document.location.replace(`/document/${formModes.read}/${data.alfrescoResponse.itemId.split("/")?.pop()}`);
								}
							}
						}
						if (data.checkResult.success) {
							ModalDialogsTemplates.messageDialog(i18n.t("done"), message, () => modalCloseFunction());
						}
						else {
							ModalDialogsTemplates.messageDialog(i18n.t("error"), data.checkResult.errorMessage, () => modalCloseFunction());
						}
					}
				});
		}
		if (requestAction === documentBpActions.refinement || requestAction === documentBpActions.reject || requestAction === documentBpActions.annul) {
			ModalDialog.showModalDialog('modalDialog', i18n.t("addComment"), "", <CommentForm handleChangeComment={save} onCloseHandler={() => { ModalDialog.hideModalDialog('modalDialog'); }} />, "feedPopup", true, []);
		}
		else save();
	}

	let needCheck = action !== documentBpActions.reject && action !== documentBpActions.addConnection;
	if (type === alfrescoTypes.counterpartyAccreditationCard || type === alfrescoTypes.simpleCounterpartyAccreditationCard || (type === alfrescoTypes.outgoingDocument && prop_sx_docKind === outgoingDocumentKinds.reconciliationAct))
		needCheck = needCheck && action !== documentBpActions.annul;
	if (type === alfrescoTypes.outgoingDocument && prop_sx_docKind === outgoingDocumentKinds.reconciliationAct)
		needCheck = needCheck && action !== documentBpActions.refinement;


	if (needCheck && !this.checkInputPage.bind(this)()) {
		if (!action) {
			const submitSaving = async function () {
				await doAction();
				ModalDialog.hideModalDialog('modalDialog');
			}

			let messageText = this.incorrectFormat ? i18n.t("saveDocumentWithIncorrectFieldsMessage") : i18n.t("saveDocumentWithNotAllDataMessage");
			if (this.checkErrorText) {
				messageText = this.checkErrorText + ' ' + i18n.t("saveDocumentWithErrorMessage");
			}

			ModalDialog.showModalDialog("modalDialog", i18n.t("attentionTitle"), "",
				<div className="info-message">{messageText}</div>,
				"feedPopup", true,
				[
					{ title: i18n.t("yes"), clickHandler: async () => await submitSaving(), class: "btn-primary" },
					{ title: i18n.t("no"), clickHandler: () => { ModalDialog.hideModalDialog('modalDialog'); onCheckFailedMessageClose.bind(currentObject)() }, class: "btn-secondary" }
				],
				() => onCheckFailedMessageClose.bind(currentObject)()
			);
		}
		else
			showCheckFailedMessage.bind(this)();
	}
	else
		await doAction();
}
export async function addAdditionaSignatory(id, type) {
	this.state.assoc_sxcfc_externalSigners_added = id;
	this.actionHandlerCallback(actionTypes.save, type);
}
export function renderAttachments(btns = []) {
	const { additionalDocuments, settings, mainDocuments, type, prop_sx_docKind } = this.state;
	let { formMode, submitted } = this.state.formMode;
	if (type === alfrescoTypes.outgoingDocument && prop_sx_docKind === outgoingDocumentKinds.mutualSettlementsAct) {
		formMode = formModes.read;
		submitted = false;
	}
	return (formMode === formModes.read && additionalDocuments.length === 0 && (!submitted || mainDocuments?.length > 0) ? "" :
		<>
			<div className="col-lg-12 attachments-header">
				<label className="required table-label">{i18n.t("attachedFiles")}</label>
				{btns.length > 0 &&
					<ul className="filter-header-buttons">
						{btns.map((item, index) =>
							<li key={formMode + "attachments" + index + item.key ?? ""} className={item.classes ?? ""}>
								<button type="button" className="btn no-bg-btn" onClick={item.onClick}><Svg src={`/img/${item.src}`} /><span>{item.title}</span></button>
							</li>)}
					</ul>
				}
			</div>
			{prop_sx_docKind !== outgoingDocumentKinds.mutualSettlementsAct && <div className="col-lg-12">
				<label className={"required"}>{i18n.t("mainDocumentFile")}</label>
				<FilesAttachmentsForm allowedExtensions={allowedMainFileExtensions} acceptString={acceptMainInputFileString} name="mainDocuments" columns={settings.mainDocumentsTable.columns} attachments={mainDocuments} actions={settings.mainDocumentsTable.actions} edite={formModes.read !== formMode} changedCallback={mainFileChanged.bind(this)} />
				{submitted && (!mainDocuments || mainDocuments.length === 0) ? <div className="help-block main-doc-help">{i18n.t("requiredField")}</div> : ""}
				<div className="form-group form-group__last">
					{formMode !== formModes.read ?
						<button onClick={() => document.getElementById("main-file-iput-controll").click()} type="button" className="btn btn-secondary">{(mainDocuments && mainDocuments.length > 0) ? i18n.t("changeDocumentFile") : i18n.t("addDocumentFile")}</button>
						: ""}
				</div>
				<input name="file" id="main-file-iput-controll" accept={acceptMainInputFileString} onChange={addMainFile.bind(this)} type="file" style={{ display: "none" }} />
			</div>}
			{(formMode === formModes.read && additionalDocuments.length === 0) || type === alfrescoTypes.simpleCounterpartyAccreditationCard ? ""
				:
				<div className="col-lg-12">
					<label>{i18n.t("additionalFiles")}</label>
					<FilesAttachmentsForm name="additionalDocuments" attachments={additionalDocuments} actions={settings.additionalDocumentsTable.actions} edite={formModes.read !== formMode} changedCallback={additionalDocumentsCallback.bind(this)} />
					<div className="form-group form-group__last">
						{formMode !== formModes.read ?
							<button onClick={() => document.getElementById("attachments-file-iput-controll").click()} type="button" className="btn btn-secondary">{i18n.t("addAdditionalFile")}</button>
							: ""}
					</div>
					<input name="file" id="attachments-file-iput-controll" accept={acceptAdditionalInputFileString} onChange={addFile.bind(this)} type="file" style={{ display: "none" }} />
				</div>
			}
		</>
	);
}
export function renderMainContract(additionalFilter = {}) {
	const { settings, associations, assoc_sxcfc_contractAssoc_added, assoc_sxcfc_contractAssoc_removed, submitted, type, prop_sx_docKind } = this.state;

	let { formMode } = this.state;
	if (type === alfrescoTypes.outgoingDocument && (prop_sx_docKind === outgoingDocumentKinds.reconciliationAct || prop_sx_docKind === outgoingDocumentKinds.mutualSettlementsAct)) {
		formMode = formModes.read;
	}

	let contractAssoc = associations?.contractAssoc;
	if (contractAssoc && assoc_sxcfc_contractAssoc_removed) {
		assoc_sxcfc_contractAssoc_removed.split(',').forEach((removed) => {
			contractAssoc = contractAssoc.filter((item) => item !== removed);
		});
	}
	let contractFormSettings = {
		title: (contractAssoc?.length > 0 || !!assoc_sxcfc_contractAssoc_added) ? i18n.t("changeMainContract") : i18n.t("addMainContract"),
		btnTitle: (contractAssoc?.length > 0 || !!assoc_sxcfc_contractAssoc_added) ? i18n.t("changeContract") : i18n.t("addContract")
	}
	return (<div className="col-lg-12">
		<label className="required table-label">{i18n.t("mainContract")}</label>
		{contractAssoc?.length > 0 || assoc_sxcfc_contractAssoc_added ? <ListOfAlfresco typeOfMenu={menuTypes.WithoutMenu} actionsForAll={settings.documentTable.onPageActions.filter(i => i.modes.includes(formModes.all) || i.modes.includes(formMode))} actionHandlerCallback={mainContractActionHandler.bind(this)} columns={["DocumentNumber", "DateDocument", "Kind"]} showPagination={false} showFilter={false} parentComponent={ListOfContracts} type={searchTableTypes.Documents} withAction={false} additionalFilter={JSON.parse(JSON.stringify({ "Id": assoc_sxcfc_contractAssoc_added ? [assoc_sxcfc_contractAssoc_added] : associations?.contractAssoc }))} />
			:
			submitted && <div className="help-block main-contract-help-block">{i18n.t("requiredField")}</div>
		}
		<div className="form-group form-group__last">
			{formModes.read !== formMode ?
				<button type="button" onClick={() => ModalDialog.showModalDialog('modalDialog', contractFormSettings.title, "", <ListOfAlfresco typeOfMenu={menuTypes.WithoutMenu} saveApi={`Table/Save?searchTableTypes=${searchTableTypes.Documents}`} withAction={false} parentComponent={ListOfContracts} type={searchTableTypes.Documents} additionalFilter={additionalFilter} actionHandlerCallback={addMainContract.bind(this)} />, "feedPopup agreement middle-size")} className="btn btn-secondary">{contractFormSettings.btnTitle}</button> : ""
			}
		</div>
	</div>);
}